import React from 'react';
import { connect } from 'react-redux';
import UserManagementMFA from '../../modules/admin/user-management/UserManagementMFA';
import feathersAuthentication from '../../services/AuthService';
import feathersServices from '../../services/feathersServices';

function Totp(props) {
  const { user, patchUser, onLogout } = props;

  const onSave = totp => {
    patchUser(user._id, {
      totp
    }).then(() => {
      setTimeout(() => {
        onLogout();
      }, 3000);
    });
  };

  return <UserManagementMFA open={true} user={user} onSave={onSave} successMessage="MFA setup completed successfully! You need to login again." />;
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.auth.user
  };
};

const mapDispatchToProps = {
  patchUser: feathersServices.users.patch,
  onLogout: feathersAuthentication.logout
};

export default connect(mapStateToProps, mapDispatchToProps)(Totp);
